import { Storage } from "@/services/Storage";
import axios from "axios";
import { responses } from "@/utils/responses";
import connectivityMonitor from "@/services/connectivityMonitor";

export default {
    name: 'cooking_instruction',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getCookingInstruction: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            const isOnline = connectivityMonitor.getStatus();

            // Cache First Strategy
            const cached = await Storage.getInstructionCatalog(store.StoreDB, payload);
            if (cached) {
                console.log(`[CookingInstruction] Using cached instructions for ${payload}`);
                // Optional: Background refresh if online could go here, but user requested 'local' feel.
                return cached;
            }

            // If not in cache and online, fetch it
            if (isOnline) {
                try {
                    const { data } = await axios.get(serverApi + `cookinginstruction/${store.StoreDB}/${payload}`);
                    if (data) {
                        await Storage.saveInstructionCatalog(store.StoreDB, payload, data);
                    }
                    return data;
                } catch (err) {
                    console.warn(`[CookingInstruction] Network fetch failed for ${payload}`, err);
                }
            }

            throw new Error("No instructions available (offline and not cached).");
        },

        cacheAllCookingInstructions: async (context) => {
            const isNativeMobile = (window?.Capacitor &&
                typeof window.Capacitor.isNativePlatform === 'function' &&
                window.Capacitor.isNativePlatform()) || window?.androidMode;
            if (isNativeMobile) {
                // Avoid heavy full-catalog prefetch on mobile; instructions remain on-demand per item.
                return;
            }

            if (!connectivityMonitor.getStatus()) {
                responses.showWarning("Must be online to sync cooking instructions");
                return;
            }

            const store = await Storage.getDefaultStore();
            const settings = await Storage.getAllStockSettings();

            let count = 0;
            const targetPlu = (Array.isArray(settings) ? settings : [])
                .filter((set) => set && set.cookingLink && set.plu)
                .map((set) => set.plu);

            for (const plu of targetPlu) {
                try {
                    const { data } = await axios.get(serverApi + `cookinginstruction/${store.StoreDB}/${plu}`);
                    if (data) {
                        await Storage.saveInstructionCatalog(store.StoreDB, plu, data);
                        count++;
                    }
                } catch (e) {
                    console.error(`Failed to cache instructions for ${plu}`, e);
                }
            }

            if (count > 0) {
                responses.showSuccess(`Synced instructions for ${count} items`);
            } else {
                responses.showInfo("No cooking instructions to sync");
            }
        }
    }
}
